'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { hasAuthExpired } from '@/lib/cookies';
import { authService } from '@/lib/api/authService';
import { adminAuthService } from '@/lib/api/adminAuthService';
import { useAuthStore } from '@/store/auth';
import { toast } from '@/lib/toast/toast';

export default function TokenExpirationChecker() {
  const router = useRouter();
  const clearUser = useAuthStore((state) => state.clearUser);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isBusinessA, setIsBusinessA] = useState(false);
  const [isBusinessB, setIsBusinessB] = useState(false);

  // Public routes that don't require authentication
  const publicRoutes = [
    '/',
    '/login',
    '/login/admin',
    '/login/business-a',
    '/login/business-b',
    '/request-demo',
    '/pay/:id',
    '/pay/new',
    '/pay/new/review',
    '/pay/new/complete',
  ];

  const isPublicRoute = () => {
    if (typeof window === 'undefined') return true;
    const currentPath = window.location.pathname;

    return publicRoutes.some((route) => {
      if (currentPath === route) return true;

      if (currentPath.startsWith('/login')) return true;

      if (route.includes(':')) {
        const routePattern = route.replace(/:[^/]+/g, '[^/]+');
        const regex = new RegExp(`^${routePattern}$`);
        return regex.test(currentPath);
      }

      return false;
    });
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsAdmin(adminAuthService.isAdminLoggedIn());
      setIsBusinessA(authService.isBusinessALoggedIn());
      setIsBusinessB(authService.isBusinessBLoggedIn());
    }
  }, []);

  useEffect(() => {
    const checkTokenExpiration = () => {
      if (isPublicRoute()) {
        return;
      }

      if (hasAuthExpired()) {
        if (isAdmin) {
          adminAuthService.logout();
          router.push('/login/admin');
          toast('success', 'Session expired. Please login again.');
        } else if (isBusinessA || isBusinessB) {
          authService.logout();
          router.push('/login/business-a');
          toast('success', 'Session expired. Please login again.');
        } else {
          clearUser();
          router.push('/login/business-a');
          toast('success', 'Session expired. Please login again.');
        }
      }
    };

    checkTokenExpiration();

    const intervalId = setInterval(checkTokenExpiration, 60 * 1000);

    return () => clearInterval(intervalId);
  }, [router, clearUser, isAdmin, isBusinessA, isBusinessB]);

  return null;
}
